// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M8 14.5C8.35 12.85 8.55 10.9 8 8.85',
  'M8 8.85C5.4 9.3 2.9 8.25 2.3 5.85C2.12 5.13 2.5 4.65 3.24 4.65C5.95 4.65 8 6.15 8 8.85Z',
  'M8 8.85C10.6 9.3 13.1 8.25 13.7 5.85C13.88 5.13 13.5 4.65 12.76 4.65C10.05 4.65 8 6.15 8 8.85Z',
];
